export const nonSpectreJourney = (journeyId?: string) =>
  journeyId?.includes('uk') ||
  journeyId?.includes('ie') ||
  journeyId?.includes('eu') ||
  journeyId?.includes('de') ||
  journeyId === 'spreadbet' ||
  journeyId === 'gtv' ||
  journeyId === 'global' ||
  journeyId?.includes('sg') ||
  journeyId === 'sgaddon' ||
  journeyId === 'sgall';
